import React from "react";
import "./ForInfluencersMain.scss";
import {whyCards, perkCards, tables, featuresCards} from "./content/CardsContent";
import {NeoButton} from "../NeoButton";
import fullPressKit from "assets/zip/neuroborncats_full_press_kit.zip";

export const ForInfluencersMain: React.FC = React.memo(() => {

    const downloadWhitePaper = () => {
        const link = document.createElement('a');
        link.href = '/assets/neuroborn_cats_white_paper.pdf';
        link.download = "neuroborn_cats_white_paper.pdf";
        link.click();
    };

    const downloadFullPressKit = () => {
        const link = document.createElement("a");
        link.href = fullPressKit;
        link.download = "neuroborncats_full_press_kit.zip";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <div className="for-influencers-main">
            <div className="title-block">
                <p className="title">
                    FOR INFLUENCERS
                </p>
            </div>
            <div className="why-block">
                <p className="title">
                    Why Neuroborn Cats?
                </p>
                <div className="cards">
                    {whyCards.map((card) => (
                        <div className="card">
                            <p className="card-title">{card.title}</p>
                            <p className="card-text">{card.text}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="perks-block">
                <div className="perks">
                    <p className="title">Exclusive Perks & Support</p>
                    <div className="subtitle">
                        Your creator benefits
                    </div>
                    <div className="cards">
                        {perkCards.map((card) => (
                            <div className="card">
                                <p className="card-title">{card.title}</p>
                                <p className="card-text">{card.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="kit-block">
                <div className="title">
                    Your Press Kit Arsenal
                </div>
                <div className="subtitle">
                    DOWNLOAD. CREATE. DOMINATE.
                </div>
                <div className="cards">
                    <div className="card card-pitch">
                        <div className="card-header">
                            <div className="card-title">
                                THE PITCH
                            </div>
                            <div className="card-subtitle">
                                Abandoned. <br/>
                                Worthless. <br/>
                                Neuroborn.
                            </div>
                        </div>
                        <div className="card-text">
                            Gatia — a planet where victory over aging spawned eternal boredom and social collapse. You are a neuroborn cat, discarded onto the streets of the cyberpunk megacity Miut. Here, swearing is small talk, violence is an argument, and sex is a bargaining chip. You don't need to survive. You need to gnaw out your place beneath this polluted sky.
                        </div>
                    </div>
                    <div className="card card-whitepaper">
                        <div className="card-content">
                            <div className="card-title">
                                GAME OVERVIEW <br/>
                                (White Paper)
                            </div>
                            <div className="card-subtitle">
                                Core USP, audience, setting
                            </div>
                            <NeoButton text="download white paper" onClick={downloadWhitePaper}/>
                        </div>
                    </div>
                    <div className="card card-kit">
                        <div className="card-header">
                            <p className="card-title">FULL PRESS KIT (ZIP)</p>
                            <p className="card-subtitle">Everything below in one click. Easy!</p>
                        </div>
                        <NeoButton text="download" onClick={downloadFullPressKit}/>
                    </div>
                </div>
            </div>
            <div className="fact-block">
                <div className="card">
                    <p className="title">
                        FACT SHEET: NEUROBORN CATS
                    </p>
                    <p className="subtitle">
                        The last document you'll need to explain this universe
                    </p>
                    <div className="content">
                        {tables.map((table) => (
                            <table className="table">
                                {table.content.map((row) => (
                                    <tr className="table-row">
                                        <td className="table-cell title">
                                            {row.title}
                                        </td>
                                        {
                                            row.text &&
                                            <td className="table-cell text">
                                                {row.text}
                                            </td>
                                        }
                                        {
                                            row.link &&
                                            <td className="table-cell link">
                                                <a href={row.link} target="_blank">{row.link}</a>
                                            </td>
                                        }
                                    </tr>
                                ))}
                            </table>
                        ))}
                    </div>
                </div>
            </div>
            <div className="features-block">
                <div className="glitch"/>
                <div className="content">
                    <div className="title-card">
                        <p className="title">
                            KEY FEATURES <br/>
                            (THE HOOK)
                        </p>
                    </div>
                    {featuresCards.map((card) => (
                        <div className="card">
                            <p className="card-title">
                                {card.title}
                            </p>
                            <p className="card-text">{card.text}
                                {card.italic && <i>{card.italic}</i>}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
});